//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState, useRef, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  CardHeader,
  CardContent,
  Typography,
} from '@mui/material';

// === COMPONENTS ===
import { LogoutButton } from '../LogoutButton/LogoutButton' ;
import { ThemeToggle  } from '../ThemeToggle/ThemeToggle'   ;
import { UserIcon     } from './UserIcon/UserIcon'          ;
import { VersionButton } from '../VersionButton/VersionButton'          ;
import {Divider} from '../../../../node_modules/@mui/material/index';
import { AppContext } from 'pages/App/components/AppContext/AppContext';


//#endregion

//-----------------------------------------------------------------
export function UserNav() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { user_details } = useContext( AppContext );

  const ref    = useRef();
  const theme  = useTheme();

  const [is_open, setIsOpen] = useState(false);

  const _styles = {
    container: {
      height: '100%',
      width: '5rem',
      display: 'block',
      padding: '0.5rem',
      zIndex: '100',
    },
    dropdown: {
      display: is_open ? '' : 'none',
      // width: 'auto',
      top: '5.5rem',
      right: '0.5rem',
      position: 'absolute',
      padding: 0,
    },
    info: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '-0.5px 0.5px 3px black',
      // position: 'fixed',
      width: '100%',
      padding: 0,
      borderRadius: 2,
      
      "&:last-child": {
        paddingBottom: 0,
     },
    }
  }

  //#endregion

  useEffect(() => {
    if(is_open) document.addEventListener   ( 'click', handleClickOutside, true );
    else        document.removeEventListener( 'click', handleClickOutside, true );

    return () => {
      if(is_open) document.removeEventListener('click', handleClickOutside, true);
    };
  }, [is_open]);

  //#region [EVENTS]

  //-----------------------------------------------------------------
  const toggleDetails = () => {
    //-----------------------------------------------------------------
    setIsOpen(!is_open);
  };

  //-----------------------------------------------------------------
  function handleClickOutside(event) {
    //-----------------------------------------------------------------
    if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
    }
  }

  //#endregion
  
  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return user_details ? display_A() : <LogoutButton />
  };

  //-----------------------------------------------------------------
  function display_A() {
    //-----------------------------------------------------------------
    // <CardHeader sx={ _styles.main } avatar={avatar} title={getDisplayName()} subheader={user_details.Email} />
    return (
      <Box sx={_styles.container} ref={ref}>
        <UserIcon onClick={toggleDetails}/> 
        <Box sx={_styles.dropdown}>
          <CardContent sx={_styles.info} >
            <CardHeader sx={ _styles.main } title={user_details.display_name} subheader={user_details.Email} />
            <Divider />
            <ThemeToggle  />
            <Divider />
            <VersionButton />
            <Divider />
            <LogoutButton />
            <Divider />        
          </CardContent>
        </Box>
      </Box>
      // <Card sx={{ marginLeft: 'auto', }} >
      //   {/* <Box sx={{display: 'flex'}}>     
      //     <IconButton aria-label='details' onClick={() => toggleDetails()}>
      //       <ExpandMore />
      //     </IconButton>
      //   </Box> */}
      //   {/* <Box sx={_styles.dropdown}>
      //     <CardContent sx={_styles.info} >
      //       <Box>
      //         <LogoutButton />
      //         <ThemeToggle  />
      //       </Box>
      //     </CardContent>
      //   </Box> */}
      // </Card>
    );
  }

  /*

    <Typography variant='h6' gutterBottom color='primary'>
      Company
    </Typography>
    <Typography variant='subtitle1' gutterBottom>
      {user_details.Company}
    </Typography>
    <Typography variant='h6' gutterBottom color='primary'>
      Assigned Roles &amp; Mods
    </Typography>
    <Box>{displayRoles()}</Box>

  */

  //-----------------------------------------------------------------
  function displayModules(modules) {
    //-----------------------------------------------------------------
    let ret = [];
    if (modules && modules.length) {
      modules.map((module, idx) => {
        ret.push(
          <Typography display='block' variant='caption' key={idx}>
            {module['ModuleName']}
          </Typography>
        );
      });
    }

    return ret;
  };

  //-----------------------------------------------------------------
  function displayRoles() {
    //-----------------------------------------------------------------
    let ret = [];
    if (user_details) {
      let idx = 0;
      if (user_details.Roles) {
        for (const role of user_details.Roles) {
          // console.log({ role });
          ret.push(
            <Box key={idx++}>
              <Typography variant='subtitle1' gutterBottom>
                {role['RoleName']}
              </Typography>
              <Box
                sx={{
                  marginLeft: theme.spacing(1),
                }}
              >
                {displayModules(role['Modules'])}
              </Box>
            </Box>
          );
        }
      }
    }
    return ret;
  };

  //#endregion

  return display();
}
